import { lazyLoad } from 'utils/loadable';

export const QuizRecordFormPage = lazyLoad(
  () => import('./index'),
  module => module.QuizRecordFormPage,
);
